import { ComplianceCaseTypeEnum } from "~/graphql/supergraphEnums";
import { type ComplianceCaseTypeEnum as ComplianceCaseTypeEnumType } from "~/graphql/supergraphTypes";

export const isEntityClientOnboardingCaseType = (
  caseType: ComplianceCaseTypeEnum | ComplianceCaseTypeEnumType,
): boolean =>
  caseType === ComplianceCaseTypeEnum.EntityOnboarding ||
  caseType === ComplianceCaseTypeEnum.ClientOnboarding;

export type CaseTypeFilterFlagOptions = {
  documentRefreshEnabled: boolean;
  entityOnboardingEnabled: boolean;
};

export const shouldIncludeCaseTypeInFilter = (
  caseType: ComplianceCaseTypeEnum,
  { documentRefreshEnabled, entityOnboardingEnabled }: CaseTypeFilterFlagOptions,
): boolean => {
  if (!documentRefreshEnabled && caseType === ComplianceCaseTypeEnum.DocumentRefresh) {
    return false;
  }
  if (!entityOnboardingEnabled && isEntityClientOnboardingCaseType(caseType)) {
    return false;
  }
  return true;
};

export const getCaseTypeFilterOptions = (
  options: CaseTypeFilterFlagOptions,
): ComplianceCaseTypeEnum[] =>
  Object.values(ComplianceCaseTypeEnum).filter((caseType) =>
    shouldIncludeCaseTypeInFilter(caseType, options),
  );

export const getDefaultCaseTypeFilterValues = (
  options: CaseTypeFilterFlagOptions,
): ComplianceCaseTypeEnum[] =>
  getCaseTypeFilterOptions(options).filter(
    (caseType) =>
      caseType !== ComplianceCaseTypeEnum.RecurringHit &&
      caseType !== ComplianceCaseTypeEnum.Escalation,
  );

export const mapCaseTypeToText = (caseType?: ComplianceCaseTypeEnum): string => {
  switch (caseType) {
    case ComplianceCaseTypeEnum.InvestorOnboarding:
      return "Investor onboarding";
    case ComplianceCaseTypeEnum.GpTransactionMonitoring:
      return "GP transaction monitoring";
    case ComplianceCaseTypeEnum.GpSourceOfFunds:
      return "GP source of funds";
    case ComplianceCaseTypeEnum.RecurringHit:
      return "Recurring hit";
    case ComplianceCaseTypeEnum.Escalation:
      return "Escalation";
    case ComplianceCaseTypeEnum.PaymentInstructionChangeReview:
      return "Payment change review";
    case ComplianceCaseTypeEnum.Remediation:
      return "Remediation";
    case ComplianceCaseTypeEnum.ChangeInCircumstance:
      return "Change in circumstance";
    case ComplianceCaseTypeEnum.DocumentRefresh:
      return "Document refresh";
    case ComplianceCaseTypeEnum.ProfileRefresh:
      return "Profile refresh";
    case ComplianceCaseTypeEnum.EntityOnboarding:
      return "Entity onboarding";
    case ComplianceCaseTypeEnum.ClientOnboarding:
      return "Client onboarding";
    default:
      return "--";
  }
};
